import { useEffect, type ReactNode } from 'react';

/**
 * Janela modal das telas de operação.
 *
 * Fecha pelo botão e pelo Esc, mas não por clique no fundo: quase toda janela
 * aqui contém um formulário com data ou valor, e perder o preenchido por um
 * clique fora seria caro.
 */

export function Dialogo({
  area,
  titulo,
  descricao,
  children,
  aoFechar,
}: {
  /** Sobrancelha do protótipo: de que área da operação é esta janela. */
  area?: string;
  titulo: string;
  descricao?: string;
  children: ReactNode;
  aoFechar: () => void;
}): React.JSX.Element {
  useEffect(() => {
    function aoTeclar(evento: KeyboardEvent): void {
      if (evento.key === 'Escape') aoFechar();
    }
    document.addEventListener('keydown', aoTeclar);
    return () => document.removeEventListener('keydown', aoTeclar);
  }, [aoFechar]);

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-[rgba(8,27,37,0.52)] p-4.5"
      role="dialog"
      aria-modal="true"
      aria-label={titulo}
    >
      <div className="max-h-[92vh] w-[min(760px,100%)] overflow-y-auto rounded-[18px] bg-superficie p-5 shadow-[0_25px_80px_rgba(0,0,0,0.25)]">
        <div className="mb-4 flex items-start justify-between gap-5">
          <div>
            {area ? (
              <div className="text-[11px] font-extrabold uppercase tracking-[0.12em] text-marinho-claro">
                {area}
              </div>
            ) : null}
            <h2 className="my-1 text-xl font-bold text-marinho">{titulo}</h2>
            {descricao ? <p className="text-[13px] text-texto-suave">{descricao}</p> : null}
          </div>
          <button
            type="button"
            onClick={aoFechar}
            aria-label="Fechar"
            className="size-[34px] shrink-0 rounded-[9px] border-0 bg-[#f1f4f6] text-texto transition hover:bg-marinho-suave"
          >
            ✕
          </button>
        </div>
        {children}
      </div>
    </div>
  );
}
